export default {
      id: "locked-balance-usage",
      viewBox: "0 0 21 18",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#locked-balance",
      toString: function () {
        return this.url;
      }
    }